import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { ProfileExportFormatted } from "../../../../../types";
import mainCss from "../kpmg_au_pptx_preview.module.scss";
import css from "./contacts.module.scss";

type ContactsProps = {
  profile: ProfileExportFormatted;
};

export const Contacts = ({ profile }: ContactsProps) => {
  console.log("profile", profile);
  const { t } = useTranslation("profiles", { keyPrefix: "export" });

  return (
    <>
      {profile.contactInformationItems
        .filter(({ type }) => type.includes("phone"))
        .map((contact, index) => (
          <div key={`contract_information_${index}`} className={classNames(mainCss.text)}>
            {t("kpmgAuPptx.phonePrefix")}:<span className={css.contact}>{contact.text}</span>
          </div>
        ))}
      <div>
        {t("kpmgAuPptx.emailPrefix")}:
        <span className={classNames(mainCss.text, css.contact, css.email)}>{profile.email}</span>
      </div>
    </>
  );
};
